// SEO Configuration for all pages
export const seoConfig = {
  // Site-wide defaults
  siteUrl: 'https://silver-jubilee.eng.ruh.ac.lk',
  siteName: 'Faculty of Engineering - University of Ruhuna',
  defaultImage: '/share-image.png',
  
  // Home Page
  home: {
    title: '25 Years of Engineering Excellence | Faculty of Engineering, University of Ruhuna',
    description: 'Celebrate 25 years of engineering excellence at the Faculty of Engineering, University of Ruhuna. Discover our legacy of innovation, education, and contribution to Sri Lanka\'s engineering landscape since 2000.',
    keywords: 'University of Ruhuna, Engineering Faculty, 25th Anniversary, Silver Jubilee, Engineering Education, Innovation, Sri Lanka, Galle, Rextro, Engineering Excellence',
    ogImage: '/share-image.png',
    canonical: '/',
  },
  
  // Events Page
  events: {
    title: 'Anniversary Events | 25th Year Celebration | University of Ruhuna',
    description: 'Join us in celebrating 25 years of the Faculty of Engineering at the University of Ruhuna. Explore our webinars, workshops, hackathons, and special anniversary events planned throughout the year.',
    keywords: 'Engineering Events, Anniversary Celebration, Webinars, Workshops, Hackathons, University of Ruhuna Events, Engineering Competitions, Tech Events Sri Lanka',
    ogImage: '/share-image.png',
    canonical: '/events',
  },
  
  // Contact Us Page
  contact: {
    title: 'Contact Us | Faculty of Engineering | University of Ruhuna',
    description: 'Get in touch with the Faculty of Engineering, University of Ruhuna. Located in Hapugala, Galle, Sri Lanka. Contact us for inquiries about programs, partnerships, and our 25th anniversary celebrations.',
    keywords: 'Contact University of Ruhuna, Engineering Faculty Contact, Galle Engineering, University Contact Details, Sri Lanka Engineering Education',
    ogImage: '/share-image.png',
    canonical: '/contact-us',
  },
  
  // 404 Page (for future use)
  notFound: {
    title: '404 - Page Not Found | University of Ruhuna',
    description: 'The page you are looking for could not be found. Return to the Faculty of Engineering 25th Anniversary celebration homepage.',
    keywords: '404, page not found',
    ogImage: '/share-image.png',
    noindex: true,
  },
};

export default seoConfig;
